if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.headers["Content-Type"] = "application/json";
        config.headers["Accept"] = "application/javascript, application/json";

        const formData = new FormData(this.form);
        const variantId = formData.get("id");

        let jsonBody = {};
        let itemsMap = {};
        let hasItems = false;

        for (let [key, val] of formData.entries()) {
          let itemsMatch = key.match(/^items\[(\d+)\]\[([^\]]+)\]/);
          if (itemsMatch) {
            hasItems = true;
            let index = parseInt(itemsMatch[1], 10);
            let prop = itemsMatch[2];
            if (!itemsMap[index]) itemsMap[index] = {};
            itemsMap[index][prop] = val;
          } else if (key === "items") {
            try {
              jsonBody.items = JSON.parse(val);
              hasItems = true;
            } catch (e) {
              jsonBody.items = val;
            }
          } else if (key.endsWith("[]")) {
            let k = key.slice(0, -2);
            if (!jsonBody[k]) jsonBody[k] = [];
            jsonBody[k].push(val);
          } else {
            if (Object.prototype.hasOwnProperty.call(jsonBody, key)) {
              if (Array.isArray(jsonBody[key])) {
                jsonBody[key].push(val);
              } else {
                jsonBody[key] = [jsonBody[key], val];
              }
            } else {
              jsonBody[key] = val;
            }
          }
        }

        if (hasItems) {
          if (Object.keys(itemsMap).length > 0) {
            jsonBody.items = (jsonBody.items || []).concat(
              Object.keys(itemsMap)
                .sort((a, b) => a - b)
                .map((k) => itemsMap[k])
            );
          }
          delete jsonBody.id;
        }

        if (this.cart) {
          jsonBody.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(",");
          jsonBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(jsonBody);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: variantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
